// Week anchors for the timesheet day view. currentWeekStart lives in the
// time-attendance SDK so the mobile Mesai week asks for the same Monday.

export { currentWeekStart } from "@novemai/time-attendance-sdk";

/** The Monday `weeks` weeks after (or, negative, before) a Monday date-only string. */
export function shiftWeek(weekStart: string, weeks: number): string {
  const date = new Date(`${weekStart}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + weeks * 7);
  return date.toISOString().slice(0, 10);
}
